.dropdownPillButton {
  position: relative;
  padding: 7px 10px;
  border-radius: 16px;
  font-family: var(--ogm-font-family-2);
  color: var(--ogm-title-color-1);
  text-decoration: underline;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
  display: flex;
  gap: 4px;
  align-items: center;

  &[aria-expanded='true'] span {
    transform: rotate(90deg);
  }

  &:hover {
    background-color: var(--ogm-dropdown-pill-color-hover-1);
  }
}

.dropdownPillIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  width: 15px;
  transform: rotate(-90deg);
}

.dropdownPanel {
  background: #fff;
  border: 1px solid var(--oc-border);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  max-height: 485px;
  overflow: scroll;
  z-index: var(--cxy-z-index-internal-mid);
}

.dropdownTitleWrapper {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: #fff;
}

.dropdownTitle {
  color: var(--ogm-black);
  font-family: var(--ogm-font-family-1);
}

.dropdownItem {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 10px 20px;
  text-align: left;
  gap: 16px;

  &:hover {
    cursor: pointer;
  }
}

.dropdownItemActive {
  background-color: var(--oc-bg-grey);
  text-decoration: none;
  pointer-events: none;

  &:hover {
    cursor: default;
  }
}

.dropdownCloseButton {
  display: flex;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.dropdownMenuSeparator {
  position: sticky;
  top: 52px;
  margin: 0;
  height: 1px;
  background-color: var(--oc-border);
  border: 0;
}
